import Result, { EmptyResult } from '@package/services/src/Result';

import { PayPalPaymentService } from './services';
import { PayPalAuthorizeRequest, PayPalCheckoutRequest, PayPalCheckoutResponse } from './types';

export default class PayPalPaymentInteractor {
  public constructor(private readonly paypalPaymentService: PayPalPaymentService) {}

  public paypalCheckout(
    request: PayPalCheckoutRequest = { skipShippingVerification: false },
  ): Promise<Result<PayPalCheckoutResponse>> {

    return this.paypalPaymentService.paypalCheckout(request);
  }

  public paypalAuthorize(request: PayPalAuthorizeRequest): Promise<EmptyResult> {
    return this.paypalPaymentService.paypalAuthorize(request);
  }
}
